import { React, useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import Table from 'react-bootstrap/Table';
import "./index.scss";

import SideNav from "../../components/PostLogin/SideNav";
import ProfileAvatar from '../../components/ui/ProfileAvatar';
import Pagination from "../../components/ui/Pagination";
import CheckBox from "../../components/ui/CheckBox";
import RadioButton from "../../components/ui/RadioButton";
import Button from "../../components/ui/Button";
import Spinner from "../../components/ui/spinner";
import NoDataFound from "../../components/ui/NoDataFound";
import DropDown from "../../components/ui/DropDown";
import SkeletonLoader from "../../components/ui/SkeletonLoader/index.js";
import { toaster } from "../../components/ui/Toaster";
import OverflowText from "../../components/ui/Textoverflow";

import DeleteScanModal from "../../components/PostLogin/ScanQueue/DeleteScanModal";

import { filterIcon, filterCloseIcon, scanQueuePauseAllIcon, scanQueueDeleteDisabledIcon, scanQueueDeleteIcon, scanQueuePauseIcon, scanQueueStartIcon, searchIcon } from "../../utils/icons.js";
import { formatDate, formatNumber, getDomainImageUrl, getUserImageUrl } from "../../utils/util.js";

import { useSelector, useDispatch } from 'react-redux';
import { getScanQueueStats, getScanQueueList, stopScanSingle, resumeScanSingle, stopScanMultiple, resetStopScanSingleResponse, resetResumeScanSingleResponse, resetDeleteScanSingleResponse, resetScanQueueList } from '../../store/actions/scanqueueAction.js';

const sortByOption = [
    {
        label: "Domain",
        value: "domain"
    },
    {
        label: "Created At",
        value: "created_at"
    },
]

const filterRadioOption = [    
    {
        label: "Ascending",
        value: "asc"
    },
    {
        label: "Descending",
        value: "desc"
    }
]

const statusOption = [
    {
        label: "In Queue",
        value: "in_queue"
    },
    {
        label: "In Progress",
        value: "in_progress"
    },
    {
        label: "Pending",
        value: "pending"
    },
    {
        label: "Stopped",
        value: "stopped"
    },
]

const scanTypeOption = [
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Passive",
        value: "passive"
    },
]

const scanSpeedOption = [
    {
        label: "Slow",
        value: "slow"
    },
    {
        label: "Moderate",
        value: "moderate"
    },
    {
        label: "Fast",
        value: "fast"
    },
]

const ScanQueue = () => {

    const scanQueueStatsResponse = useSelector((state) => state.scanQueue?.scanQueueStatsResponse);
    const scanQueueListResponse = useSelector((state) => state.scanQueue?.scanQueueList);
    const stopScanSingleResponse = useSelector((state) => state.scanQueue?.stopScanSingleResponse);
    const resumeScanSingleResponse = useSelector((state) => state.scanQueue?.resumeScanSingleResponse);
    const stopScanMultipleResponse = useSelector((state) => state.scanQueue?.stopScanMultipleResponse);
    const deleteScanSingleResponse = useSelector((state) => state.scanQueue?.deleteScanSingleResponse)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const filterWrapperRef = useRef(null);

    //search value
    const [scanSearchValue, setScanSearchValue] = useState("");
    const [ScanSearchedValue, setScanSearchedValue] = useState("");
    const [isScanQueueSearchFocused, setIsScanQueueSearchFocused] = useState(false);

    //filter values
    const [selectedScanStatus, setSelectedScanStatus] = useState("");
    const [selectedScanType, setSelectedScanType] = useState("");
    const [selectedScanSpeed, setSelectedScanSpeed] = useState("");
    const [selectedSortby, setSelectedSortby] = useState("");
    const [selectedSortOrder, setSelectedSortOrder] = useState("");
    
    //selected filter value
    const [filterSelectedScanStatus, setFilterSelectedScanStatus] = useState("");
    const [filterSelectedScanType, setFilterSelectedScanType] = useState("");
    const [filterSelectedScanSpeed, setFilterSelectedScanSpeed] = useState("");
    const [filterSelectedSortby, setFilterSelectedSortby] = useState("");
    const [filterSelectedSortOrder, setFilterSelectedSortOrder] = useState("");

    const [filterList, setFilterList] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [isStatsLoading, setIsStatsLoading] = useState(false);
    const [updateStatusLoading, setUpdatedStatusLoading] = useState(false);
    const [selectedScan, setSelectedScan] = useState(false);
    const [scanQueueList, setScanQueueList] = useState(null);

    const removeFilter = (type) => {
        setCurrentPage(1);
        if(type === "status") {
            setSelectedScanStatus("");
            setFilterSelectedScanStatus("");
        } else if(type === "scanType") {
            setSelectedScanType("");
            setFilterSelectedScanType("");
        } else if(type === "scanSpeed") {
            setSelectedScanSpeed("");
            setFilterSelectedScanSpeed("");
        } else if (type === "sortorder") {
            setSelectedSortOrder("");
            setFilterSelectedSortOrder("")
        } else if (type === "sortby") {
            setSelectedSortby("");
            setSelectedSortOrder("");
            setFilterSelectedSortby("");
            setFilterSelectedSortOrder("");
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        setFilterSelectedScanStatus(selectedScanStatus);
        setFilterSelectedScanType(selectedScanType);
        setFilterSelectedScanSpeed(selectedScanSpeed);
        setFilterSelectedSortby(selectedSortby);
        setFilterSelectedSortOrder(selectedSortOrder);
        setShowFilter(false);
    }

    const displaySortByName = (type) => {
        if (type === "status") {
            const matchedOption = statusOption.find((data) => data.value === selectedScanStatus)
            return matchedOption ? matchedOption.label : "";
        } else if(type === "scanType") {
            const matchedOption = scanTypeOption.find((data) => data.value === selectedScanType)
            return matchedOption ? matchedOption.label : "";
        } else if(type === "scanSpeed") {
            const matchedOption = scanSpeedOption.find((data) => data.value === selectedScanSpeed)
            return matchedOption ? matchedOption.label : "";
        } else if (type === "sortOrder") {
            const matchedOption = filterRadioOption.find((data) => data.value === selectedSortOrder)
            return matchedOption ? matchedOption.label : "";
        } else {
            const matchedOption = sortByOption.find((data) => data.value === selectedSortby)
            return matchedOption ? matchedOption.label : "";
        }
    }

    const filterClicked = () => {
        setShowFilter(true)
    }    

    const showModal = (data) => {
        setSelectedData(data)
        setModalShow(true);
    };

    const resumeScan = (data) => {
        setSelectedScan(data)
        setUpdatedStatusLoading(true)
        let obj = {
            scan_id: data.scan_id
        }
        dispatch(resumeScanSingle(obj));
    }

    const stopScan = (data) => {
        setSelectedScan(data)
        setUpdatedStatusLoading(true)
        let obj = {
            scan_id: data.scan_id
        }        
        dispatch(stopScanSingle(obj));
    }

    const PauseMultiple = () => {
        let ids = selectedValue.map((data)=>{
            return data.scan_id
        })
        let obj = {
            scan_ids: [...ids]
        }
        dispatch(stopScanMultiple(obj))
    }

    const changeSelectAll = (e) => {
        if(e.target.checked) {
            setSelectedValue(scanQueueList?.results)
        } else {
            setSelectedValue([])
        }
    }

    const isChecked = (data) => {
        if(selectedValue.length > 0 ){
            return selectedValue.some(item => item.scan_id === data.scan_id);
        }
        return false
    }

    const setselectedCheckboxValue = (e) => {
        if(e.target.checked) {
            let checkedValue = scanQueueList?.results.filter(item => item.scan_id === e.target.value);
            setSelectedValue([...selectedValue, ...checkedValue])
        } else {
            const updatedList = selectedValue.filter(item => item.scan_id !== e.target.value);
            setSelectedValue(updatedList);
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isScanQueueSearchFocused) {
            ScanQueueSearch()
        }
    }

    const ScanQueueSearch = () => {
        setCurrentPage(1)
        setScanSearchedValue(scanSearchValue)
    }

    const fetchScanQueueList = useCallback(()=>{
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const queryParams = ScanSearchedValue ? `&query=${ScanSearchedValue}` : "";
        const sortParams = (filterSelectedScanStatus ? `&scan_status=${filterSelectedScanStatus}` : '') + (filterSelectedScanType ? `&scan_type=${filterSelectedScanType}` : '') + (filterSelectedScanSpeed ? `&scan_speed=${filterSelectedScanSpeed}` : '') + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
        const url = `${baseUrl}${queryParams}${sortParams}`;
        setIsLoading(true);
        dispatch(getScanQueueList(url));
    },[currentPage, currentPageSize, dispatch, ScanSearchedValue, filterSelectedScanStatus, filterSelectedScanType, filterSelectedScanSpeed, filterSelectedSortby, filterSelectedSortOrder])

    const fetchScanQueueStats = useCallback(()=>{
        setIsStatsLoading(true);
        dispatch(getScanQueueStats());
    },[dispatch])

    useEffect(()=>{
        fetchScanQueueList();
    },[fetchScanQueueList])

    useEffect(()=>{
        fetchScanQueueStats()
    },[fetchScanQueueStats])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                    setFilterList([])
                }
            }
        
        }
    },[showFilter,filterList]);


    useEffect(()=>{
        if(scanQueueListResponse !== null) {
            setScanQueueList(scanQueueListResponse)
            setIsLoading(false)
            dispatch(resetScanQueueList())
        }
    },[scanQueueListResponse, dispatch])

    useEffect(()=>{
        if(stopScanSingleResponse !== null) {
            if(stopScanSingleResponse?.detail?.status === "success") {
                toaster.addToast(stopScanSingleResponse?.detail?.description, "success");
                fetchScanQueueList();
                fetchScanQueueStats();
            } else {
                toaster.addToast(stopScanSingleResponse?.description, "error");
            }
            setSelectedScan("")
            setUpdatedStatusLoading(false)
            dispatch(resetStopScanSingleResponse())
        }
    },[stopScanSingleResponse, fetchScanQueueList, dispatch, fetchScanQueueStats])

    useEffect(()=>{
        if(resumeScanSingleResponse !== null) {
            if(resumeScanSingleResponse?.detail?.status === "success") {
                toaster.addToast(resumeScanSingleResponse?.detail?.description, "success");
                fetchScanQueueList();
                fetchScanQueueStats();
            } else {
                toaster.addToast(resumeScanSingleResponse?.description, "error");
            }
            setSelectedScan("")
            setUpdatedStatusLoading(false)
            dispatch(resetResumeScanSingleResponse())
        }
    },[resumeScanSingleResponse, dispatch, fetchScanQueueList, fetchScanQueueStats])

    useEffect(()=>{
        if(stopScanMultipleResponse !== null) {
            if(stopScanMultipleResponse?.detail?.status === "success") {
                toaster.addToast(stopScanMultipleResponse?.detail?.description, "success");
                setSelectedValue([]);
                fetchScanQueueList();
                fetchScanQueueStats();
            } else {
                toaster.addToast(stopScanMultipleResponse?.description, "error");
            }
        }
    },[stopScanMultipleResponse, fetchScanQueueList, fetchScanQueueStats])

    useEffect(()=>{
        if(deleteScanSingleResponse !== null) {
            if(deleteScanSingleResponse?.detail?.status === "success") {
                toaster.addToast(deleteScanSingleResponse?.detail?.description, "success");
                setSelectedValue([]);
                fetchScanQueueList();
                fetchScanQueueStats();
            } else {
                toaster.addToast(deleteScanSingleResponse?.description, "error");
            }
            setModalShow(false)
            dispatch(resetDeleteScanSingleResponse())
        }
    },[deleteScanSingleResponse, fetchScanQueueList, fetchScanQueueStats, dispatch])

    useEffect(()=>{
        if(scanQueueStatsResponse !== null) {
            setIsStatsLoading(false)
        }
    },[scanQueueStatsResponse])

    return (
        <div className="organization-details-container">
            <SideNav />
            <div className="organization-page-container">
                <div className="page-header-container px-4 py-3 d-flex align-items-center justify-content-between">
                    <div className="header-left d-flex align-items-center gap-3">
                        <h1>{t("scanQueuePage.heading")}</h1>
                    </div>
                </div>
                <div className="page-main-section px-4 py-3">
                    <div className="organization-header-container p-3 my-3 rounded">
                        <div className="d-flex gap-3">
                            <div className="total-score-container rounded scan-queue-count">
                                {
                                    isStatsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage="scanQueue" />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="users-totol-count d-flex">
                                            <p className="total-user-count">{formatNumber(scanQueueStatsResponse?.scans?.total)}</p>
                                            <div className="user-count mx-3 mt-2">
                                                <span className="active d-inline-block mx-1"></span>
                                                <span className="disbled d-inline-block"></span>
                                                <p>{t("scanQueuePage.scans")}</p>
                                            </div>
                                        </div>
                                        <div className="active-disabled-count d-flex gap-3">
                                            <p className="active-user"><span className="d-inline-block">{formatNumber(scanQueueStatsResponse?.scans?.active)}</span> {t("scanQueuePage.activeScans")}</p>
                                            <p className="disabled-user"><span className="d-inline-block">{formatNumber(scanQueueStatsResponse?.scans?.passive)}</span> {t("scanQueuePage.passiveScans")}</p>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                            <div className="total-domains-container scan-queue-page rounded">
                                {
                                    isStatsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage="scanQueue" />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <p className="total-domain">{formatNumber(scanQueueStatsResponse?.scans?.normal)}</p>
                                        <p className="domain-text">{t("scanQueuePage.adhocScan")}</p>
                                    </motion.div>
                                }                                
                            </div>
                            <div className="total-domains-container scan-queue-page rounded">
                                {
                                    isStatsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage="scanQueue" />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <p className="total-domain">{formatNumber(scanQueueStatsResponse?.scans?.monitor)}</p>
                                        <p className="domain-text">{t("scanQueuePage.autoScan")}</p>
                                    </motion.div>
                                }                                
                            </div>
                        </div>
                    </div>
                    <div className="organization-main-container p-3">
                        <div className="search-filter-container my-3 d-flex justify-content-between align-items-center">
                            <div className="search-container d-flex align-items-center gap-3">
                                <div className="position-relative" onKeyDown={handleSearchKeyDown}>
                                    <input className="search-input rounded" 
                                        placeholder="Search Scan" 
                                        value={scanSearchValue} 
                                        onChange={(e)=>setScanSearchValue(e.target.value)}
                                        onFocus={() => setIsScanQueueSearchFocused(true)}
                                        onBlur={() => setIsScanQueueSearchFocused(false)}
                                    />
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                </div>
                                <button className="search-btn" onClick={ScanQueueSearch}>{t("scanQueuePage.search")}</button>
                                <div className="position-relative">
                                    <span className="filter-icon" onClick={filterClicked}>{filterIcon()}</span>
                                    {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>                                
                                        <h6>Scan Status</h6>
                                            <DropDown 
                                                placeHolder={"Scan status"}
                                                options={statusOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedScanStatus(data.value)}}
                                                defaultSelectedValue={selectedScanStatus}
                                            />
                                        <h6 className="mt-4">Scan Type</h6>
                                            <DropDown 
                                                placeHolder={"Scan Type"}
                                                options={scanTypeOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedScanType(data.value)}}
                                                defaultSelectedValue={selectedScanType}
                                            />
                                        <h6 className="mt-4">Scan Speed</h6>
                                            <DropDown 
                                                placeHolder={"Scan Speed"}
                                                options={scanSpeedOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedScanSpeed(data.value)}}
                                                defaultSelectedValue={selectedScanSpeed}
                                            />
                                        <h6 className="mt-4">Sort By</h6>
                                            <DropDown 
                                                placeHolder={"Sort By"}
                                                options={sortByOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedSortby(data.value)}}
                                                defaultSelectedValue={selectedSortby}
                                            />
                                        <h6 className="mt-4">Sort Order</h6>
                                        <div className="filter-user-status d-flex mb-4 gap-4">
                                            {
                                                filterRadioOption.map((data,index)=>{
                                                    return (
                                                        <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(data)=>{setSelectedSortOrder(data)}} key={index} isChecked={data.value === selectedSortOrder} />
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="filter-apply-btn mt-3">
                                            <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                                        </div>
                                    </div>}
                                </div>
                                {!showFilter && <p className="selected-filters">
                                    {filterSelectedScanStatus !== "" && <span className="d-inline-block mx-2">{displaySortByName("status")} <span onClick={() => removeFilter("status")}>{filterCloseIcon()}</span></span>}
                                    {filterSelectedScanType !== "" && <span className="d-inline-block mx-2">{displaySortByName("scanType")} <span onClick={() => removeFilter("scanType")}>{filterCloseIcon()}</span></span>}
                                    {filterSelectedScanSpeed !== "" && <span className="d-inline-block mx-2">{displaySortByName("scanSpeed")} <span onClick={() => removeFilter("scanSpeed")}>{filterCloseIcon()}</span></span>}
                                    {filterSelectedSortby !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortby")} <span onClick={() => removeFilter("sortby")}>{filterCloseIcon()}</span></span>}
                                    {filterSelectedSortOrder !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortOrder")} <span onClick={() => removeFilter("sortorder")}>{filterCloseIcon()}</span></span>}
                                </p>}
                            </div>
                            <div className="sort-edit-container scan-queue-page">
                                <div className="container d-flex gap-3 align-items-center">                                    
                                    <button className="edit-btn pause-scan-btn" disabled={selectedValue.length === 0} onClick={()=>{PauseMultiple()}}>
                                        <span className="d-inline-block mx-1">{scanQueuePauseAllIcon()}</span>
                                        {t("scanQueuePage.pauseScan")}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="domain-table-container scan-queue-table">
                            {
                                isLoading ? 
                                    <div className="d-flex align-items-center justify-content-center domain-loader">
                                        <SkeletonLoader type={"line"} count={5} currentPage={"scanQueue"} />
                                    </div>
                                :
                                <Table responsive="lg" className="table-fixed">
                                    <thead>
                                        <tr>
                                            <th className="select-all-checkbox"><CheckBox checkBoxId={0} checkBoxValue={"select all"} handleCheckboxChange={changeSelectAll}/></th>
                                            <th className="domain-data">{t("scanQueuePage.domainDetails")}</th>
                                            <th className="scan-data">{t("scanQueuePage.scanDetails")}</th>
                                            <th className="scan-type-data">{t("scanQueuePage.scanType")}</th>
                                            <th className="scan-status-data">{t("scanQueuePage.scanStatus")}</th>
                                            <th className="scan-check-point-data">{t("scanQueuePage.checkpoint")}</th>
                                            <th className="scan-stopped-data">{t("scanQueuePage.scanStoped")}</th>
                                            <th className="scan-action-data"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            scanQueueList?.results.length > 0 ?
                                            scanQueueList?.results.map((data, index)=>{
                                                return (
                                                    <motion.tr
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        // whileInView={{ opacity: 1, y: 0 }}
                                                        // viewport={{ once: true }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <td className="checkbox-data">
                                                            <CheckBox checkBoxId={index} checkBoxValue={data.scan_id} handleCheckboxChange={setselectedCheckboxValue} isChecked={isChecked(data)}/>
                                                        </td>
                                                        <td className="domain-data">
                                                            <ProfileAvatar type="domain" name={data.domain} imageUrl={getDomainImageUrl(data)} />
                                                        </td>
                                                        <td className="scan-data">
                                                            <ProfileAvatar pageType={"domainTable"} type="profile" firstName={data?.created_by?.name} lastName={""} imageUrl={getUserImageUrl(data.created_by)}  secondaryText={`${formatDate(data?.created_at)}`}/>
                                                            {/* <p>{`Scan Created at ${formatDate(data?.created_at)}`}</p> */}
                                                        </td>
                                                        <td className="scan-type-data">
                                                            <label className={`text-capitalize scan-type ${data.scan_type === "passive" ? "passive" : 'active'}`}>{data.scan_type}</label></td>
                                                        <td className="scan-status-data">
                                                            {data.scan_status === "in_progress" && <div className="scan-progress inprogress">
                                                                <h4>In progress - {data.scan_percentage}%</h4>
                                                                <div className="progress-container"> 
                                                                    <div style={{width:`${data.scan_percentage}%`}}></div> 
                                                                </div>
                                                            </div>}
                                                            {data.scan_status === "pending" && 
                                                                <div className="scan-progress queued">
                                                                <h4>Pending - {data.scan_percentage}%</h4>
                                                                <div className="progress-container"> 
                                                                    <div style={{width:`${data.scan_percentage}%`}}></div> 
                                                                </div>
                                                            </div>}
                                                            {data.scan_status === "in_queue" && 
                                                                <div className="scan-progress queued">
                                                                <h4>In Queue - {data.scan_percentage}%</h4>
                                                                <div className="progress-container"> 
                                                                    <div style={{width:`${data.scan_percentage}%`}}></div> 
                                                                </div>
                                                            </div>}
                                                            {data.scan_status === "stopped" && 
                                                                <div className="scan-progress queued">
                                                                <h4>Stopped - {data.scan_percentage}%</h4>
                                                                <div className="progress-container"> 
                                                                    <div style={{width:`${data.scan_percentage}%`}}></div> 
                                                                </div>
                                                            </div>}
                                                        </td>
                                                        <td className="scan-check-point-data">
                                                            <OverflowText text={data.scan_checkpoint} className={"score"}/>
                                                        </td>
                                                        <td className="scan-stopped-data">
                                                            { data.scan_status === "stopped" ? 
                                                                <ProfileAvatar pageType={"domainTable"} type="profile" firstName={data?.stopped_by?.name} lastName={" "} imageUrl={getUserImageUrl(data?.stopped_by)} /> 
                                                                : 
                                                                <p>-</p> 
                                                            }
                                                        </td>
                                                        <td className="scan-action-data">                                                             
                                                            {updateStatusLoading && selectedScan.scan_id === data.scan_id ? <Spinner height={"30"} width={"30"}/> 
                                                                :
                                                                <>
                                                                    {data.scan_status === "in_progress" && <div className="d-flex gap-2 scan-action-btn">
                                                                    <span className="cursor-pointer" onClick={()=>{stopScan(data)}}>{scanQueuePauseIcon()}</span>
                                                                        {scanQueueDeleteDisabledIcon()}
                                                                    </div>}
                                                                    {data.scan_status === "pending" && <div className="d-flex gap-2 scan-action-btn">
                                                                    <span className="cursor-pointer" onClick={()=>{stopScan(data)}}>{scanQueuePauseIcon()}</span>
                                                                        {scanQueueDeleteDisabledIcon()}
                                                                    </div>}
                                                                    {data.scan_status === "in_queue" && <div className="d-flex gap-2 scan-action-btn">
                                                                    <span className="cursor-pointer" onClick={()=>{stopScan(data)}}>{scanQueuePauseIcon()}</span>
                                                                        {scanQueueDeleteDisabledIcon()}
                                                                    </div>}
                                                                    {data.scan_status === "stopped" && <div className="d-flex gap-2 scan-action-btn">
                                                                        <span className="cursor-pointer" onClick={()=>{resumeScan(data)}}>{scanQueueStartIcon()}</span>
                                                                        <span className="cursor-pointer" onClick={()=>{showModal(data)}}>{scanQueueDeleteIcon()}</span>
                                                                    </div>}
                                                                </> 
                                                            }
                                                        </td>
                                                    </motion.tr>
                                                )
                                            })
                                            :                                             
                                                <motion.tr
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4 }}
                                                >
                                                    <td colSpan="8" style={{ textAlign: 'center' }}>
                                                        <NoDataFound />
                                                    </td>
                                                </motion.tr>
                                        }
                                    </tbody>
                                </Table>
                            }
                            
                            {scanQueueList != null && scanQueueList?.results.length > 0 && !isLoading && <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={scanQueueList.meta.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />}
                        </div>
                    </div>
                    <DeleteScanModal show={modalShow} onHide={() => setModalShow(false)} deleteDomainData={selectedData}/>
                </div>
            </div>
        </div>
    )
}

export default ScanQueue;